export default __webpack_public_path__ + "static/media/send-to-vote.1c8b33f7.svg";